import baseTheme from "./baseTheme";
const theme = ({ fontFamily } = {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"'
})=>baseTheme({
        fontFamily,
        themeOverrides: {
            headerNavBg: '#fff',
            headerNavColor: '#FFF',
            brandColor: '#827127',
            splashColor: '#44444F'
        }
    });
export default theme;
